<template>
  <div class="component-task-types">
    <label class="checkbox"
      v-for="(name, code) of taskTypes" :key="code"
    >
      <input type="checkbox" v-model="selected" :value="code">
        {{ name }}
    </label>
  </div>
</template>

<script lang='ts'>
import { Component, Prop, Vue } from 'vue-property-decorator'
import { TaskType, TaskTypeCode } from '@/store/deadlines/types'

@Component
export default class TaskTypesInput extends Vue {
  @Prop() value!: TaskTypeCode[]

  private taskTypes = TaskType

  private get selected(): TaskTypeCode[] {
    return this.value
  }

  private set selected(taskTypes: TaskTypeCode[]) {
    this.$emit('input', taskTypes)
  }
}
</script>

<style scoped>
.component-task-types {
  display:flex;
  flex-wrap: wrap;
}

input[type="checkbox"] {
  margin-right:8px;
}
.checkbox {
  margin-right:20px;
}
</style>
